<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle1"><a id="page_xi"></a>L<span class="small">OST TO</span> T<span class="small">IME</span></p>
<p class="halftitle2">UNFORGETTABLE STORIES THAT HISTORY FORGOT</p>
<p class="imagex"><a id="page_xii"></a><img alt="jpg" src="Images/Art_Pxii_1.jpg" style="max-width: 100%;"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?0bd8105a